import React from "react";
import profileIcon from "../../assets/images/thep.png"; // Your provided profile icon
import starIcon from "../../assets/images/Star.png";       // Your star icon

const DoctorAssignedCard = ({ doctorName = "Dr. Name", doctorImage, className = "" }) => {
  return (
    <div className={className} style={styles.card}>
      <div style={styles.title}>Doctor Assigned</div>
      <div style={styles.content}>
        <img src={doctorImage || profileIcon} alt="Profile" style={styles.profileImg} />
        <div>
          <div style={styles.name}>{doctorName}</div>
          <div style={styles.speciality}>Physiotherapy Specialist</div>
          <div style={styles.rating}>
            <img src={starIcon} alt="Star" style={styles.starIcon} />
            <span style={styles.ratingValue}>4.9</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  card: {
    backgroundColor: "#fff",
    borderRadius: 20,
    padding: 16,
    paddingRight: 16,
    paddingLeft: 16,
    marginRight: 10,
    marginLeft: 10,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    // width: "100%",
  },
  title: {
    color: "#2E2E2E",
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "2px",
  },
  content: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  profileImg: {
    width: "74px",
    height: "74px",
    borderRadius: "12px",
    backgroundColor: "#FFEEDD",
    Object: "cover",
    padding: "2px",
  },
  name: {
    fontSize: "19px",
    color: "#3C2A4D",
    fontWeight: "400",
  },
  speciality: {
    color: "#3A3A3A",
    fontSize: "14px",
    marginTop: "4px",
  },
  rating: {
    display: "flex",
    alignItems: "center",
    marginTop: "0px",
  },
  starIcon: {
    width: "16px",
    height: "16px",
    marginRight: "6px",
  },
  ratingValue: {
    color: "#F79F1F",
    fontWeight: "600",
    fontSize: "16px",
  },
};

export default DoctorAssignedCard;
